import React from "react";

// Single-line file name that truncates in the middle, so the extension stays
// visible (e.g. "apollo_hosp…logo.png"). The full name is shown on hover.
const TAIL_LENGTH = 8;

const SelectedFileName = ({ name, style }) => {
  if (!name) {
    return null;
  }
  const head = name.length > TAIL_LENGTH ? name.slice(0, -TAIL_LENGTH) : "";
  const tail = name.length > TAIL_LENGTH ? name.slice(-TAIL_LENGTH) : name;
  return (
    <div
      title={name}
      style={{
        display: "flex",
        minWidth: 0,
        fontSize: "0.8rem",
        color: "#555",
        ...style,
      }}
    >
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {head}
      </span>
      <span style={{ whiteSpace: "nowrap", flexShrink: 0 }}>{tail}</span>
    </div>
  );
};

export default SelectedFileName;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/SelectedFileName.js